export default "/_next/static/images/dfd8b6cea907600be9550a3294b054b5.png";